import { ReactComponent as Building } from 'static/images/specialize/building.svg'
import { ReactComponent as Consulting } from 'static/images/specialize/consulting.svg'
import { ReactComponent as Outsourcing } from 'static/images/specialize/out-sourcing.svg'

export const CONTENTS = [
  {
    label: 'Consulting',
    descriptions:
      'Receive consultation from Web3 experts and OG blockchain builders with 6+ years hands-on experience. We offer Enterprise IT Consulting, Solution Consulting, Platform Consulting and other on-demand services.',
    icon: Consulting,
  },
  {
    label: 'Outsourcing',
    descriptions:
      'Get your own global hackathon-winning dev team, available 24/7. Our scope of work covers everything from Application Development, Infrastructure Design & Management, UX/UI Design to on-demand services.',
    icon: Outsourcing,
  },
  {
    label: 'Building in-house teams',
    descriptions:
      'Let us form your dream team of world-class technicians in the Solana blockchain. Optimize your cost, save your time! Contact us for more information.',
    icon: Building,
  },
]
